import request from '@/request/http'
// 普通文件上传
export function uploadOss(data) {
    return request({
        url: '/file/handle/uploadOss',
        method: 'post',
        data: data,
    })
}

//根据文件id获取文件详情
export function getFileInfo(id) {
    return request({
        url: '/file/handle/getFileInfo?fileId='+id,
        method: 'post',
    })
}

//根据文件id获取预览地址
export function previewFile(id) {
    return request({
        url: '/file/handle/previewFile?fileId='+id,
        method: 'post',
    })
}

//分片初始化
export function chunkInit(data){
    return request({
        url: '/file/handle/initiateUpload',
        method: 'post',
        data
    })
}

//分片上传
export function chunkUpload(data){
    return request({
        url: '/file/handle/uploadChunk',
        method: 'post',
        data
    })
}
//OSS文件下载
export function ossDownload(id){
    return request({
        url: '/file/handle/oosDownload?fileId='+id,
        method: 'post',
        responseType: 'arraybuffer'
    })
}
